/**
 * @repo/shared/hooks - Hooks 统一导出
 */

export { useCloseOnScroll } from "./useCloseOnScroll"
